// Keys we explicitly render in the finding detail view
export const RENDERED_FINDING_KEYS = new Set([
  'id',
  'title',
  'type',
  'severity',
  'cwe',
  'cwe_id',
  'file_path',
  'line_range',
  'function_name',
  'confidence',
  'description',
  'code_snippet',
  'remediation',
  'cvss_score',
  'cvss_vector',
  'verification',
]);

// Keys we explicitly render in the exploit detail view
export const RENDERED_EXPLOIT_KEYS = new Set([
  'id',
  'success',
  'status',
  'reasoning',
  'poc_code',
  'success_indicators',
  'commands_summary',
  'vulnerability_report',
]);
